<template>
    <div class="content">
        <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
            <assistant-manager>
            </assistant-manager> 
            </div>
        </div>  
        </div>
    </div>
    </template>
    <script>
    /* eslint-disable */
    import assistantManager from './todo-assistant-manager'
    export default {
        components: {
            assistantManager
        }
    }
    </script>
    <style lang="scss">
    </style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/bp-users/base-assistant-manager.vue